import { useSwitchState } from '../useSwitchState'
import UnsavedChangesModal, {
  UnsavedChangesModalProps,
} from 'components/modals/UnsavedChangesModal'

type HookProps = Omit<UnsavedChangesModalProps, 'isOpen'> & {
  onDiscard?: () => void
  onKeepEditing?: () => void
}

const useUnsavedChangesModal = (props: HookProps) => {
  const [
    isUnsavedChangesModalOpen,
    openUnsavedChangesModal,
    closeUnsavedChangesModal,
  ] = useSwitchState()

  const handleKeepEditing = () => {
    props.onKeepEditing?.()
    closeUnsavedChangesModal()
  }

  const handleDiscard = () => {
    props.onDiscard?.()
    closeUnsavedChangesModal()
  }

  const renderConfirmModal = () => {
    return (
      <UnsavedChangesModal
        {...props}
        isOpen={isUnsavedChangesModalOpen}
        onDiscard={handleDiscard}
        onKeepEditing={handleKeepEditing}
      />
    )
  }

  const triggerModal = () => {
    if (isUnsavedChangesModalOpen) {
      closeUnsavedChangesModal()
    } else {
      openUnsavedChangesModal()
    }
  }

  return {
    triggerModal,
    renderConfirmModal,
    isUnsavedChangesModalOpen,
    openUnsavedChangesModal,
    closeUnsavedChangesModal,
  }
}

export default useUnsavedChangesModal
